module.exports = __webpack_public_path__ + "img/add.350334e8.png";